/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export default class PageNotFound extends Component<never> {
  browserCryImage = new URL('cio/assets/images/browser-cry.svg', import.meta.url).toString();
}
